<template>
    <div class="baseImgRight">
        <div class="baseImgTitle">
            <span href="#" class="contentTitle" @click="back()" v-for="(item,index) in navigationList" :key="index">
                {{langes==0?(item.barName?item.barName:item[parentEle.title]):(item.barName?item.barEngName:item[parentEle.title+'En'])}}
                <span v-if="index!=navigationList.length-1">></span>
            </span>
           <!-- 显示标题内容--->
            <span href="#" v-if="isShowTitle"  @click="back()">
                > {{barTitle}}
            </span>
        </div>
        <div class="baseImgContent" v-if="!detailShow">
            <ul>
                <li v-for="(item,index) in imgList"
                    :key="index"
                    :style="{marginRight:(index+1)%2 == 0? '0' : '15px'}"
                    @click="imgClick(item)">
                    <a href="#">
                        <img :src="imageUrl+item.solutionLogo" alt/>
                    </a>
                      <p style="font-size:17px;" v-if="langes==0">
                         {{item.solutionContentTitle}}
                        </p>
                    <p style="font-size:17px" v-else>{{item.solutionContentTitleEn}}</p>
                    <p style="font-size:15px; line-height: 5px;">{{item.updateTime}}</p>
                </li>
            </ul>
            <div class="bottom">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="100"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div>
        </div>
        <div v-else>
            <div class="detaildiv">
                <p class="detailTitle">
                    {{detailObj.solutionContentTitle}}
                </p>
               
            </div>
            <div class="updateTimeDiv">
                <span class="span">日期:{{detailObj.createTime}}</span>
            </div>
            <p v-html="detailObj.solutionContent"></p>
        </div>
    </div>
</template>

<script type="es6">
    /* eslint-disable */
    export default {
         name: 'baseImg',
        props: {
            currentObj: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                navigationList: [],
                currentPage: 1,
                total: 0,
                imageUrl: this.$api.imageUrl,
                imgList: [],
                searchObj: {
                    pageNum: 1,
                    pageSize: 9
                },
                detailObj: {},
                detailShow: false,
                langes: 0,
                barTitle:"",
                isShowTitle:false
            }
        },
        inject: ['parentEle'],
        watch: {
            currentObj: {
                deep: true,
                handler: function (val) {
                    this.getList(val.id);
                    this.detailShow = false;
                    this.navigationList = JSON.parse(sessionStorage.getItem('pathList'))
                }
            }
        },
        mounted() {
            this.langes = sessionStorage.getItem('watchStorage');
            window.addEventListener('setItem', () => {
                this.langes = sessionStorage.getItem('watchStorage');
            })
        },
        methods: {
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchObj.pageNum = val;
                this.getList(this.currentObj.id);
            },
            // 获取列表
            getList(val) {
                this.$api.get(`/api/web/get_solution_page_list`, {
                    solutionId: val,
                    ...this.searchObj
                }).then(res => {
                    this.imgList = res.response.list;
                    this.total = res.response.total;
                })
            },
            imgClick(item) {
                this.detailObj = {...item};
                this.detailShow = true;
                this.barTitle = this.detailObj.solutionContentTitle
                this.isShowTitle = false
            },
            back(){
                 this.detailShow = false;
                 this.isShowTitle = false
            }
        }
    }
</script>

<style scoped lang="less">
    .baseImgRight {
        width: calc(~"100% - 253px");
        float: right;
        .baseImgTitle {
            height: 27px;
            padding-top: 6px;
           // background: url("http://www.worldelite.net.cn/data/templates/cn/img/title_bg.jpg") repeat-x;
            line-height: 27px;
            padding-left: 12px;
            color: #747575;
            text-align: left;
            & > span {
                color: #747575;
                cursor: pointer;
            }

            & > span:last-child {
                cursor: initial;
            }
            .contentTitle{
                font-size: 17px;
            }
        }

        .baseImgContent {
            padding-top: 12px;
            padding-bottom: 12px;
            color: #706f6f;
            line-height: 1.8;
            overflow: auto;
            width: 600px;
            height: 650px;
            li {
                width: 230;
                height: 350px;
                float: left;
                text-align: center;
                margin-bottom: 20px;
                margin-right: 15px;
                padding-bottom: 10px;
                box-shadow: #c7c7c7 0 4px 4px;
                img {
                   width: 230px;
                    height: 230px;
                }
            }

            .bottom {
                width: 100%;
                margin-top: 10px;
                display: flex;
                justify-items: center;
                justify-content: center;
                align-items: center;
            }
        }
        .detaildiv{
            display: flex;
            flex-flow: row;
            justify-content: center;
            align-items: center;
            width: 100%;
        }
       .updateTimeDiv{
            border-left-width: 4px;
            border-left-color: #015EB7;
            border-left-style: solid;
            height: 30px;
            background:#44cef6;
            //opacity:0.1;
            .span {
                line-height: 28px;
                color: #333;
                font-weight: normal;
                font-size: 13px;
                padding-left: 10px;
            }
        }
        .detailTitle {
            display: block;
            //border-bottom: 1px solid #1069b6;
            //font-weight: bold;
            font-size: 20px;
            color: #333;
            text-align: left;
            padding-bottom: 4px;
            line-height: 28px;
            // span {
            //     float: right;
            //     line-height: 28px;
            //     color: #666;
            //     font-weight: normal;
            //     font-size: 11px;
            // }
        }
    }
</style>